import axios from 'axios'

class MentalHealthSurveyQuestionnaire {
  constructor() {
    this.baseUrl = '/api/v1'
  }

  getAllQuestions(data) {
    return axios.post(`${this.baseUrl}/survey/get_survey_questions/`, data)
  }

  saveAllAnswers(data) {
    return axios.post(`${this.baseUrl}/survey/survey_answers/`, data)
  }
}

export const mentalHealthSurveyQuestionnaire =
  new MentalHealthSurveyQuestionnaire()
